"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PonziEditDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_intl_1 = require("react-intl");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const mui_dialog_form_1 = require("@dzambalaorg/mui-dialog-form");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const mui_inputs_draft_1 = require("@dzambalaorg/mui-inputs-draft");
const mui_inputs_mask_1 = require("@dzambalaorg/mui-inputs-mask");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const types_1 = require("@framework/types");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const inputs_1 = require("../../../../../../inputs");
const types_2 = require("../../../../../../types");
const validation_1 = require("./validation");
const PonziEditDialog = (props) => {
    const { selectedItem, open, mode, readOnly, service, ...rest } = props;
    if (!open || !selectedItem) {
        return null;
    }
    const { id, title, description, penalty, maxCycles, deposit, reward, durationAmount, durationUnit, contractId } = selectedItem;
    const fixedValues = {
        id,
        title,
        description,
        deposit,
        reward,
        penalty,
        maxCycles,
        durationAmount,
        durationUnit,
        contractId,
    };
    return ((0, jsx_runtime_1.jsxs)(mui_dialog_form_1.FormDialog, { open: open, initialValues: fixedValues, validationSchema: validation_1.validationSchema, message: `dialogs.${mode}`, testId: "PonziStakingEditForm", filter: ({ title, description }) => ({
            title,
            description,
        }), ...rest, children: [(0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: "contractId", controller: "contracts", fetchData: {
                    contractModule: [types_1.ModuleType.PONZI],
                    contractStatus: [types_1.ContractStatus.ACTIVE, types_1.ContractStatus.NEW],
                } }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "title" }), (0, jsx_runtime_1.jsx)(mui_inputs_draft_1.RichTextEditor, { name: "description" }), (0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, spacing: 2, children: [readOnly ? ((0, jsx_runtime_1.jsx)(material_1.Grid, { size: { xs: 12 }, children: (0, jsx_runtime_1.jsx)(material_1.Box, { mt: 2, children: (0, jsx_runtime_1.jsx)(ui_kit_1.Alert, { severity: "warning", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "alert.editNotAllowed" }) }) }) })) : null, (0, jsx_runtime_1.jsx)(material_1.Grid, { size: { xs: 12, sm: 6 }, children: (0, jsx_runtime_1.jsx)(mui_inputs_asset_1.TemplateAssetInput, { autoSelect: true, prefix: "deposit", readOnly: readOnly, contract: { data: { contractModule: [types_1.ModuleType.HIERARCHY] } } }) }), (0, jsx_runtime_1.jsx)(material_1.Grid, { size: { xs: 12, sm: 6 }, children: (0, jsx_runtime_1.jsx)(mui_inputs_asset_1.TemplateAssetInput, { autoSelect: true, prefix: "reward", readOnly: readOnly, contract: { data: { contractModule: [types_1.ModuleType.HIERARCHY] } } }) })] }), (0, jsx_runtime_1.jsx)(inputs_1.DurationInput, { readOnly: readOnly }), (0, jsx_runtime_1.jsx)(mui_inputs_mask_1.CurrencyInput, { name: "penalty", symbol: "", InputProps: {
                    endAdornment: (0, jsx_runtime_1.jsx)(material_1.InputAdornment, { position: "start", children: "%" }),
                }, readOnly: readOnly }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.NumberInput, { name: "maxCycles" }), service === types_2.ServiceType.ADMIN && (0, jsx_runtime_1.jsx)(mui_inputs_core_1.CheckboxInput, { name: "recurrent", readOnly: readOnly })] }));
};
exports.PonziEditDialog = PonziEditDialog;
//# sourceMappingURL=index.js.map